import { render } from "./StammdatenTable.vue?vue&type=template&id=f18a01be&scoped=true"
import script from "./StammdatenTable.vue?vue&type=script&lang=js"
export * from "./StammdatenTable.vue?vue&type=script&lang=js"

import "./StammdatenTable.vue?vue&type=style&index=0&id=f18a01be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f18a01be"]])

export default __exports__